import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqItems } from "../../data/faq";
import { deliveryText, refundText } from "../../utils/commerce";
import { SectionHeading } from "../ui/SectionHeading";
export function Faq() {
  const [open, setOpen] = useState<string | null>(faqItems[0].id);
  const answerFor = (answer: string, key?: "delivery" | "refund") => key === "delivery" ? deliveryText() : key === "refund" ? refundText() : answer;
  return <section id="preguntas" aria-labelledby="preguntas-title" className="scroll-mt-20 bg-crema/60 py-20 md:py-28" data-id="element-80" data-mp="3ltp9qxzzlzhf">
      <div className="mx-auto max-w-3xl px-4 md:px-6" data-id="element-81" data-mp="3gwfkpjgifpu4">
        <SectionHeading id="preguntas-title" eyebrow="Preguntas frecuentes" title="Lo que conviene saber antes de elegir" data-id="element-82" data-mp="3bxw1hqtaws5g" />
        <ul className="mt-12 divide-y divide-pizarra/15 border-y border-pizarra/15" data-id="element-83" data-mp="1f4anptk5m2cj">
          {faqItems.map(f => {
          const isOpen = open === f.id;
          return <li key={f.id} data-id="element-84" data-mp="1cp6i18hxf6kj">
                <h3 data-id="element-85" data-mp="1cowv5ts6hfj2">
                  <button type="button" id={`faq-btn-${f.id}`} aria-expanded={isOpen} aria-controls={`faq-panel-${f.id}`} onClick={() => setOpen(isOpen ? null : f.id)} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[17px] font-semibold text-pizarra-deep" data-id="element-86" data-mp="1hpb1n7e4shez">
                    {f.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-terracota-deep transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-87" data-mp="20f99pnhxiaim" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-88" data-mp="2edqrz5p2eut5">
                  {isOpen && <motion.div id={`faq-panel-${f.id}`} role="region" aria-labelledby={`faq-btn-${f.id}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-89" data-mp="2j8d5pfimczge">
                      <p className="pb-6 pr-8 leading-relaxed text-pizarra" data-id="element-90" data-mp="2a5hl2v4ze9bx">{answerFor(f.answer, f.configKey)}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}